module.exports = __webpack_public_path__ + "static/stamp-animation-b1d3879b75f521c4b68e51e9ea02e7ea.png";